module.exports = __webpack_public_path__ + "media/images/fallback/avatar/public_default-b59bf4201386bc57f4cb8bbbb17459fd.png";